import React from 'react';
import { VolleyballIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-navy px-4 py-24 text-center text-white" data-id="element-49" data-mp="3n4w8ryifi9ie">
      <Reveal className="mx-auto max-w-3xl" data-id="element-50" data-mp="3s2xsmlnoicux">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-brand-coral" data-id="element-51" data-mp="welphkyr71w">
          <VolleyballIcon className="h-7 w-7" aria-hidden="true" data-id="element-52" data-mp="2zejvs98btmky" />
        </div>
        <h2 className="mt-5 text-4xl font-black uppercase leading-[1.05] tracking-tight md:text-5xl" data-id="element-53" data-mp="34c25i1u645u0">
          Gotowy, by wnieść siatkówkę na każde boisko?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-54" data-mp="399tvurf5zjw3">
          Oszczędź czas na planowaniu i prowadź każdy trening z jasnym planem, dobrymi ćwiczeniami i pełną pewnością
          siebie.
        </p>
        <CTAButton className="mt-9 px-10 py-5 text-base md:text-lg" data-id="element-55" data-mp="2llu53rhurthi">CHCĘ PAKIET GOTOWI NA SIATKÓWKĘ</CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-56" data-mp="26vafbw8hdqva">
          Natychmiastowy dostęp · Wersja do druku · 30-dniowa gwarancja
        </p>
      </Reveal>
    </section>;
}